import React from 'react';
import PropTypes from 'prop-types';

import styles from '../../../styles/views/components/Filter/FilterChip.module.scss';
import CloseIcon from '../../../../assets/cross-icon-new.svg';

export default function FilterChip({ text, onCloseIconClick, hideCloseIcon }) {
  return (
    <div className={styles.container}>
      <div className={styles.text}>{text}</div>
      {!hideCloseIcon && (
        <div onClick={onCloseIconClick} className={styles.closeIcon}>
          <CloseIcon fill="#0C1B1E" width="10" height="10" viewBox="0 0 20 20" />
        </div>
      )}
    </div>
  );
}

FilterChip.propTypes = {
  text: PropTypes.string.isRequired,
  onCloseIconClick: PropTypes.func,
  hideCloseIcon: PropTypes.bool.isRequired,
};

FilterChip.defaultProps = {
  onCloseIconClick: () => {},
};
